import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { WarningExclamationIcon } from '@/common/icons/general.tsx'
import { Button } from '@/common/components/Button.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import { LogUserActivity } from '@/apis/users/requests'
import { LOG_TYPES } from '../constants'
import { HomeIcon } from '@/common/icons/menu.tsx'
import { IconType } from '@/common/icons/types.ts'
import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { StateQueries } from '@/queries/states/queries.ts'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice.ts'

const ResidencyAlternativeDocsInfo = () => {
  const {t: translate} = useTranslation();
  const navigateTo = useNavigate()
  const programSettings = useSelector(selectProgramSettings)
  const hasLoggedPageView = useRef(false);
  const stateQuery = useQuery(
    StateQueries.getStateById(programSettings.global_state_id, {
      staleTime: Infinity,
    })
  )

  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: "I don't have any of these documents. (Residency)"
      })
      hasLoggedPageView.current = true;
    }
  }, [])


  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        {translate('residency_verification')}
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content>
        <h2 className="text-xl font-medium text-gray-900 mb-10 sm:mb-5">
          {translate('residency_docs.submit_2_docs')}
        </h2>
        <div>
          <div className="flex">
            <HomeIcon type={IconType.Filled} className='pt-1'/>
            <h3 className="ml-2 font-medium">{translate('alt_docs')}</h3>
          </div>
          <div className="mt-4 mb-5">
            <ul className="ml-6 mt-2 text-gray-700 space-y-2 list-['-_']">
              <li>{translate('residency_docs.letter_from_government')}</li>
              <li>{translate('residency_docs.pay_stub')}</li>
              <li>{translate('residency_docs.bank_statement')}</li>
              <li><h4>{translate('residency_docs.utility_bill')}</h4>
                <ul className="ml-6 mt-2 text-gray-700 space-y-2 list-['-_']">
                  <li>{translate('residency_docs.utility_bills.gas_bill')}</li>
                  <li>{translate('residency_docs.utility_bills.electric_bill')}</li>
                  <li>{translate('residency_docs.utility_bills.home_or_mobile_phone_bill')}</li>
                  <li>{translate('residency_docs.utility_bills.cable_bill')}</li>
                </ul>
              </li>
              <li>{translate('residency_docs.us_mail_change_address_form')}</li>
              <li>{translate('residency_docs.driver_license')}</li>
              <li>{translate('residency_docs.vehicle_registration')}</li>
              <li>{translate('residency_docs.state_photo_identification_card', {state: stateQuery.data?.name ?? ''})}</li>
              <li>{translate('residency_docs.voter_registration_doc')}</li>
              <li>{translate('residency_docs.religious_records')}</li>
              <li><h4>{translate('residency_docs_within_past_year')}</h4>
                <ul className="ml-6 mt-2 text-gray-700 space-y-2 list-['-_']">
                  <li>{translate('residency_docs.within_past_year.w2')}</li>
                  <li>{translate('residency_docs.within_past_year.vehicle_tax_bill')}</li>
                  <li>{translate('residency_docs.within_past_year.property_tax_bill')}</li>
                </ul>
              </li>
            </ul>
            <div className="mt-6 flex items-center rounded-md px-2 py-2 text-xs font-medium ring-1 ring-inset bg-primary-50 ring-primary-600/20">
              <WarningExclamationIcon className="text-sm" />
              <span className="text-gray-600 ml-2">
                {translate('residency_docs_requirement_prompt')}
              </span>
            </div>
          </div>
        </div>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar>
        <Button
          onClick={() => {
            navigateTo(
              AppRoutePaths.family_application.residency_verification
                .alternative_docs_capture
            )
          }}
          className="w-full"
        >
          {translate('upload_doc_residency')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
export default ResidencyAlternativeDocsInfo;
